import { Transaction } from '../abstract/transaction.model';
import { CreditCard } from '../credit-cards/credit-card.model';
import { CreditCardTransactionAllocation } from './credit-card-transaction-allocation.model';

export class CreditCardTransaction extends Transaction {

    static override CLASS_NAME: string = 'CreditCardTransaction';

    private _creditCard!: CreditCard;

    /*----------------------------------------------------------------------------------------
     * Accesseurs
     ----------------------------------------------------------------------------------------*/

    public get allocations(): CreditCardTransactionAllocation[] {
        return this._allocations as CreditCardTransactionAllocation[];
    }

    public set allocations(value: any) {
        this._setValue('_allocations', value, 'CreditCardTransactionAllocation');
    }

    public get creditCard(): CreditCard {
        return this._creditCard;
    }

    public set creditCard(value: any) {
        this._setValue('_creditCard', value, 'CreditCard');
    }

}
